(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lymphelle-cart-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const root = document.querySelector('.lymphelle-native');
      const drawer = root?.querySelector('[data-lym-cart-drawer]');
      const itemsNode = root?.querySelector('[data-lym-cart-items]');
      const footNode = root?.querySelector('[data-lym-cart-foot]');
      const source = document.querySelector('[data-lym-cart-enhancements]');
      if (!root || !drawer || !itemsNode || !footNode || !source || drawer.dataset.enhancedCart === 'true') return;
      drawer.dataset.enhancedCart = 'true';

      const shipping = source.content.querySelector('[data-lym-shipping-meter]').cloneNode(true);
      drawer.querySelector('.lym-cart-head')?.after(shipping);
      const shippingCopy = shipping.querySelector('[data-lym-shipping-copy]');
      const shippingProgress = shipping.querySelector('[data-lym-shipping-progress]');
      const totalNode = drawer.querySelector('[data-lym-cart-total]');
      const summaryNode = drawer.querySelector('[data-lym-cart-summary]');
      const routesRoot = window.Shopify?.routes?.root || '/';
      const shippingThresholds = {USD:5000,CAD:7000,GBP:4000,AUD:7500};
      const sourceAttribute = (name) => source.getAttribute(name) || '';
      const decodeHtml = (value) => {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = value || '';
        return textarea.value;
      };
      const bundleImages = {
        1: 'https://cdn.shopify.com/s/files/1/0745/0427/4087/files/lymphelle-bundle-1.webp?v=1789674115',
        3: 'https://cdn.shopify.com/s/files/1/0745/0427/4087/files/lymphelle-bundle-3.webp?v=1789674125',
        5: 'https://cdn.shopify.com/s/files/1/0745/0427/4087/files/lymphelle-bundle-5.webp?v=1789674106'
      };
      const bundleConfigs = [
        {id:Number(sourceAttribute('data-bundle-1-ot')),size:1,kind:'one_time',image:bundleImages[1],nextId:Number(sourceAttribute('data-bundle-3-ot')),nextSize:3,nextPrice:Number(sourceAttribute('data-price-3-ot')),nextImage:bundleImages[3],offer:source.dataset.buy2Get1},
        {id:Number(sourceAttribute('data-bundle-1-sub')),size:1,kind:'subscribe',image:bundleImages[1],nextId:Number(sourceAttribute('data-bundle-3-sub')),nextSize:3,nextPrice:Number(sourceAttribute('data-price-3-sub')),nextImage:bundleImages[3],nextPlan:sourceAttribute('data-plan-3'),offer:source.dataset.buy2Get1},
        {id:Number(sourceAttribute('data-bundle-3-ot')),size:3,kind:'one_time',image:bundleImages[3],nextId:Number(sourceAttribute('data-bundle-5-ot')),nextSize:5,nextPrice:Number(sourceAttribute('data-price-5-ot')),nextImage:bundleImages[5],offer:source.dataset.buy3Get2},
        {id:Number(sourceAttribute('data-bundle-3-sub')),size:3,kind:'subscribe',image:bundleImages[3],nextId:Number(sourceAttribute('data-bundle-5-sub')),nextSize:5,nextPrice:Number(sourceAttribute('data-price-5-sub')),nextImage:bundleImages[5],nextPlan:sourceAttribute('data-plan-5'),offer:source.dataset.buy3Get2},
        {id:Number(sourceAttribute('data-bundle-5-ot')),size:5,kind:'one_time',image:bundleImages[5]},
        {id:Number(sourceAttribute('data-bundle-5-sub')),size:5,kind:'subscribe',image:bundleImages[5]}
      ];
      const bundleById = new Map(bundleConfigs.map((config) => [config.id, config]));
      const bumpConfigs = [
        {id:Number(source.dataset.brushId),title:source.dataset.brushTitle,image:source.dataset.brushImage,price:Number(source.dataset.brushPrice),compare:Number(source.dataset.brushCompare || 0),copy:decodeHtml(source.dataset.brushCopy),emphasis:decodeHtml(source.dataset.brushEmphasis)},
        {id:Number(source.dataset.protectionId),title:source.dataset.protectionTitle,image:source.dataset.protectionImage,price:Number(source.dataset.protectionPrice),compare:0,copy:source.dataset.protectionCopy,emphasis:''}
      ];
      const bumpIds = new Set(bumpConfigs.map((config) => config.id));
      let renderingCart = false;

      const formatMoney = (amount, currency) => {
        const activeCurrency = currency || 'USD';
        const locale = {USD:'en-US',CAD:'en-CA',GBP:'en-GB',AUD:'en-AU'}[activeCurrency] || document.documentElement.lang || 'en-US';
        return new Intl.NumberFormat(locale,{style:'currency',currency:activeCurrency}).format(amount / 100);
      };
      const requestCart = async (path, payload) => {
        const response = await fetch(routesRoot + path, {
          method: payload ? 'POST' : 'GET',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:payload ? JSON.stringify(payload) : undefined
        });
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      };
      const setLoading = (state) => drawer.classList.toggle('is-enhancement-loading', state);
      const setCount = (count) => root.querySelectorAll('[data-lym-cart-count]').forEach((node) => { node.textContent = String(count); });

      const changeLine = async (key, quantity) => {
        setLoading(true);
        try {
          await requestCart('cart/change.js', {id:key,quantity});
          await loadCart();
        } finally {
          setLoading(false);
        }
      };

      const upgradeLine = async (item, config, button) => {
        if (!config.nextId) return;
        button.disabled = true;
        setLoading(true);
        let addedKey = '';
        try {
          const nextItem = {id:config.nextId,quantity:item.quantity};
          if (config.nextPlan) nextItem.selling_plan = config.nextPlan;
          const added = await requestCart('cart/add.js', {items:[nextItem]});
          addedKey = added.items?.[0]?.key || '';
          await requestCart('cart/change.js', {id:item.key,quantity:0});
          await loadCart();
        } catch (error) {
          if (addedKey) await requestCart('cart/change.js', {id:addedKey,quantity:0}).catch(() => {});
        } finally {
          setLoading(false);
          button.disabled = false;
        }
      };

      const toggleBump = async (config, button, cart) => {
        button.disabled = true;
        setLoading(true);
        try {
          const existing = cart.items.find((item) => Number(item.variant_id) === config.id);
          if (existing) {
            await requestCart('cart/change.js', {id:existing.key,quantity:0});
          } else {
            await requestCart('cart/add.js', {items:[{id:config.id,quantity:1,properties:{_order_bump:'true'}}]});
          }
          await loadCart();
        } finally {
          setLoading(false);
          button.disabled = false;
        }
      };

      const makeUpgrade = (item, config, currency) => {
        const currentPerPack = item.final_price / Math.max(1,config.size);
        const nextPerPack = config.nextPrice / Math.max(1,config.nextSize);
        const savePerPack = Math.max(0,currentPerPack-nextPerPack);
        const additionalPacks = Math.max(0,config.nextSize-config.size);
        const additionalPrice = Math.max(0,config.nextPrice-item.final_price);
        const additionalPerPack = additionalPrice / Math.max(1,additionalPacks);
        const card = document.createElement('div');
        card.className = 'lym-cart-upgrade';
        const image = document.createElement('img');
        image.className = 'lym-cart-upgrade__image';
        image.src = config.nextImage;
        image.alt = '';
        image.width = 60;
        image.height = 60;
        const copy = document.createElement('div');
        copy.className = 'lym-cart-upgrade__copy';
        const badge = document.createElement('span');
        badge.className = 'lym-cart-upgrade__badge';
        badge.textContent = source.dataset.bestValue;
        const saving = document.createElement('small');
        saving.className = 'lym-cart-upgrade__saving';
        saving.textContent = `${source.dataset.saveLabel} ${formatMoney(savePerPack,currency)} ${source.dataset.perPack}`;
        const title = document.createElement('strong');
        title.textContent = `+${additionalPacks} ${source.dataset.packs} ${source.dataset.forLabel} ${formatMoney(additionalPrice,currency)} - ${formatMoney(additionalPerPack,currency)} ${source.dataset.each}`;
        const shippingText = document.createElement('small');
        shippingText.textContent = source.dataset.freeShipping;
        copy.append(badge,saving,title,shippingText);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lym-cart-upgrade__button';
        button.textContent = source.dataset.upgrade;
        button.addEventListener('click', () => upgradeLine(item, config, button));
        card.append(image,copy,button);
        return card;
      };

      const makeBump = (config, cart, currency) => {
        const selected = cart.items.some((item) => Number(item.variant_id) === config.id);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lym-bump-card';
        button.setAttribute('aria-pressed', String(selected));
        const check = document.createElement('span');
        check.className = 'lym-bump-card__check';
        check.setAttribute('aria-hidden','true');
        const image = document.createElement('img');
        image.className = 'lym-bump-card__image';
        image.src = config.image;
        image.alt = '';
        image.width = 66;
        image.height = 66;
        const copy = document.createElement('span');
        copy.className = 'lym-bump-card__copy';
        const title = document.createElement('strong');
        title.textContent = config.title;
        const detail = document.createElement('small');
        detail.append(document.createTextNode(config.copy + ' '));
        if (config.emphasis) {
          const emphasis = document.createElement('strong');
          emphasis.textContent = config.emphasis;
          detail.append(emphasis);
        }
        copy.append(title,detail);
        const price = document.createElement('span');
        price.className = 'lym-bump-card__price';
        const current = document.createElement('strong');
        current.textContent = formatMoney(config.price,currency);
        price.append(current);
        if (config.compare > config.price) {
          const compare = document.createElement('s');
          compare.textContent = formatMoney(config.compare,currency);
          price.append(compare);
        }
        button.append(check,image,copy,price);
        button.addEventListener('click', () => toggleBump(config,button,cart));
        return button;
      };

      const makeItem = (item, cart) => {
        const config = bundleById.get(Number(item.variant_id));
        const row = document.createElement('div');
        row.className = 'lym-cart-item';
        const image = document.createElement('img');
        image.src = config?.image || item.image || '';
        image.alt = '';
        image.width = 74;
        image.height = 74;
        const copy = document.createElement('div');
        copy.className = 'lym-cart-item-copy';
        const title = document.createElement('strong');
        title.textContent = item.product_title;
        const variant = document.createElement('small');
        variant.textContent = item.variant_title === 'Default Title' ? '' : item.variant_title;
        copy.append(title,variant);
        if (item.selling_plan_allocation?.selling_plan?.name || (config?.kind === 'subscribe')) {
          const plan = document.createElement('small');
          plan.className = 'lym-cart-selling-plan';
          plan.textContent = item.selling_plan_allocation?.selling_plan?.name || source.dataset.subscriptionActive;
          copy.append(plan);
        }
        const quantity = document.createElement('div');
        quantity.className = 'lym-cart-qty';
        const minus = document.createElement('button');
        minus.type = 'button';
        minus.textContent = '−';
        minus.setAttribute('aria-label',source.dataset.decrease);
        minus.addEventListener('click',() => changeLine(item.key,Math.max(0,item.quantity-1)));
        const value = document.createElement('span');
        value.textContent = String(item.quantity);
        const plus = document.createElement('button');
        plus.type = 'button';
        plus.textContent = '+';
        plus.setAttribute('aria-label',source.dataset.increase);
        plus.addEventListener('click',() => changeLine(item.key,item.quantity+1));
        quantity.append(minus,value,plus);
        copy.append(quantity);
        const side = document.createElement('div');
        side.className = 'lym-cart-item-price';
        const linePrice = document.createElement('span');
        linePrice.textContent = formatMoney(item.final_line_price,cart.currency);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'lym-cart-remove';
        remove.textContent = source.dataset.remove;
        remove.addEventListener('click',() => changeLine(item.key,0));
        side.append(linePrice,remove);
        row.append(image,copy,side);
        const fragment = document.createDocumentFragment();
        fragment.append(row);
        if (config?.nextId) fragment.append(makeUpgrade(item,config,cart.currency));
        return fragment;
      };

      const renderCart = (cart) => {
        renderingCart = true;
        const threshold = shippingThresholds[cart.currency] || shippingThresholds.USD;
        const mainItems = cart.items.filter((item) => !bumpIds.has(Number(item.variant_id)));
        const hasDrops = mainItems.some((item) => bundleById.has(Number(item.variant_id)));
        setCount(cart.item_count || 0);
        if (summaryNode) summaryNode.textContent = cart.item_count
          ? `${cart.item_count} ${cart.item_count === 1 ? source.dataset.itemSingular : source.dataset.itemPlural}`
          : source.dataset.emptyTitle;
        if (totalNode) totalNode.textContent = formatMoney(cart.total_price || 0,cart.currency);
        footNode.hidden = !cart.item_count;
        shipping.hidden = !cart.item_count;
        const remaining = Math.max(0,threshold-(cart.total_price || 0));
        if (shippingCopy) shippingCopy.innerHTML = remaining
          ? `${source.dataset.shippingPrefix} <strong>${formatMoney(remaining,cart.currency)}</strong> ${source.dataset.shippingSuffix}`
          : `<strong>${source.dataset.shippingUnlocked}</strong>`;
        if (shippingProgress) shippingProgress.style.width = `${Math.min(100,((cart.total_price || 0)/threshold)*100)}%`;
        itemsNode.replaceChildren();
        if (!mainItems.length) {
          const empty = document.createElement('div');
          empty.className = 'lym-cart-empty';
          const title = document.createElement('strong');
          title.textContent = source.dataset.emptyTitle;
          const copy = document.createElement('span');
          copy.textContent = source.dataset.emptyCopy;
          empty.append(title,copy);
          itemsNode.append(empty);
          window.setTimeout(() => { renderingCart = false; },0);
          return;
        }
        mainItems.forEach((item) => itemsNode.append(makeItem(item,cart)));
        if (hasDrops) {
          const bumps = document.createElement('section');
          bumps.className = 'lym-cart-bumps';
          const heading = document.createElement('h3');
          heading.textContent = source.dataset.completeOrder;
          bumps.append(heading);
          bumpConfigs.forEach((config) => bumps.append(makeBump(config,cart,cart.currency)));
          itemsNode.append(bumps);
        }
        window.setTimeout(() => { renderingCart = false; },0);
      };

      const loadCart = async () => {
        let cart = await requestCart('cart.js');
        const hasDrops = cart.items.some((item) => bundleById.has(Number(item.variant_id)));
        const orphanBumps = cart.items.filter((item) => bumpIds.has(Number(item.variant_id)));
        if (!hasDrops && orphanBumps.length) {
          for (const item of orphanBumps) await requestCart('cart/change.js',{id:item.key,quantity:0});
          cart = await requestCart('cart.js');
        }
        renderCart(cart);
        return cart;
      };

      const trustText = [...drawer.querySelectorAll('.lym-cart-trust-list strong')].find((node) => node.textContent.trim() === 'Shipping & Easy Returns');
      if (trustText) trustText.textContent = 'Fast Shipping & Easy Returns';
      const checkoutButton = drawer.querySelector('.lym-checkout');
      if (checkoutButton && !drawer.querySelector('.lym-cart-payment-icons')) {
        const paymentImage = document.createElement('img');
        paymentImage.className = 'lym-cart-payment-icons';
        paymentImage.src = source.dataset.paymentImage;
        paymentImage.alt = source.dataset.paymentAlt;
        paymentImage.width = 760;
        paymentImage.height = 56;
        paymentImage.loading = 'lazy';
        checkoutButton.after(paymentImage);
      }
      root.querySelectorAll('[data-lym-cart-open]').forEach((button) => button.addEventListener('click',() => {
        [350,900,1700].forEach((delay) => window.setTimeout(() => { loadCart().catch(() => {}); },delay));
      }));
      root.querySelector('.lym-product-form')?.addEventListener('submit',() => {
        [450,1100,1900].forEach((delay) => window.setTimeout(() => { loadCart().catch(() => {}); },delay));
      });
      new MutationObserver(() => {
        if (drawer.classList.contains('is-open')) window.setTimeout(() => { loadCart().catch(() => {}); },120);
      }).observe(drawer,{attributes:true,attributeFilter:['class']});
      new MutationObserver(() => {
        if (!renderingCart) window.setTimeout(() => { loadCart().catch(() => {}); },120);
      }).observe(itemsNode,{childList:true});
      [400,1100].forEach((delay) => window.setTimeout(() => { loadCart().catch(() => {}); },delay));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
